import axios from 'axios';
import Vue from 'vue';
import { ACCESS_TOKEN, ACCESS_HEADER, SET_SITE,ALL_SET_SITE, SET_LANGUAGE } from '@/store/mutation-types'
import router from '../router/index';
// 统一请求路径前缀
let base = '';
// 超时设定
axios.defaults.timeout = 30000;

axios.interceptors.request.use(config => {
    let accessToken =  Vue.ls.get(ACCESS_TOKEN)
    let accessHeader = Vue.ls.get(ACCESS_HEADER)
    if(accessHeader && accessToken){
        Object.assign(config.headers, {
            [accessHeader]:accessToken,
            "Accept-Language":Vue.ls.get(SET_LANGUAGE)
        })
    }
    return config;
}, err => {
    console.error('请求超时');
    return Promise.resolve(err);
});

// http response 拦截器
axios.interceptors.response.use(response => {
    const data = response.data;

    // 根据返回的code值来做不同的处理(和后端约定)
    switch (data.code) {
        case 401:
            // 未登录 清除已登录状态

            break;
        case 403:
            // 没有权限

            break;
        case 404:
            // 没有权限

            break;
        case 505:
            // 没有权限

            break;
        case 500:
            // 错误

            break;
        case 10003:
            Vue.ls.remove(ACCESS_TOKEN)
            Vue.ls.remove(ACCESS_HEADER)
            Vue.ls.remove(SET_SITE)
            Vue.ls.remove(ALL_SET_SITE)
            router.push({ path: '/user/login' })
            break;
        default:
            return data;
    }

    return data;
}, (err) => {
    // 返回状态码不为200时候的错误处理
    if(err.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
        console.log("调取数据时间超时了呦~")
    }else{
        console.log(err.toString())
    }
    return Promise.resolve(err);
});

export const postFormRequest = (url, params) => {
    let  formData = new FormData();
    for(let key in params){
        formData.append(key, params[key])
    }
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: formData,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params
    });
};

export const postRequest = (url, params, headers = {
    'Content-Type': 'application/json'
}) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        headers: headers
    });
};


export const exportRequest = (url, params, headers = {
    'Content-Type': 'application/json'
}) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        responseType: 'blob',
        headers: headers
    });
};


export const deleteRequest = (url, params) => {
    return axios({
        method: 'delete',
        url: `${base}${url}`,
        params: params
    });
};

// 默认导出axios实例，以便在组件中直接使用
export default axios;

